import React, { forwardRef } from "react";
import type { IButtonProps } from "../types";
import { Button as ButtonComponent } from "./components";

export const Button = forwardRef<
  HTMLButtonElement | HTMLDivElement,
  IButtonProps
>((props, ref) => {
  return <ButtonComponent {...props} ref={ref} />;
});

Button.displayName = "Button";
